import { AxiosError } from 'axios'
import { FC } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import { useSelectedProjectPremises } from '@/api/models/main/hooks/useSelectedProjectPremises'
import { RequestByIdApiType } from '@/api/models/requests'
import { ServerValidationError } from '@/api/shared/types'
import { PassFormHeader } from '@/components/entities/passes/ui/PassForms/FormBlock/PassFormHeader'
import { RequestDatePickerFormBlock } from '@/components/entities/requests/ui/FormBlock/RequestDatePickerFormBlock'
import { RequestRoomPickerFormBlock } from '@/components/entities/requests/ui/FormBlock/RequestRoomPickerFormBlock'
import { useFormDirty } from '@/components/entities/requests/ui/hooks/useFormDirty'
import { CourierPassFormData } from '@/components/entities/requests/ui/model/schemas'
import { getDefaultRoom } from '@/components/entities/requests/ui/model/utils'
import { DrawerFormLayout } from '@/components/shared/drawer-form-layout'

type Props = {
  onFormDirty: (_: boolean) => void
  pass?: RequestByIdApiType
  onSubmit: (data: CourierPassFormData) => Promise<void>
  passError?: AxiosError<ServerValidationError> | null
  isPending?: boolean
}

const CourierPassForm: FC<Props> = ({
  onFormDirty,
  pass,
  onSubmit,
  passError,
  isPending
}) => {
  const { rooms } = useSelectedProjectPremises()

  const form = useForm({
    mode: 'onSubmit',
    defaultValues: {
      room: getDefaultRoom(rooms, pass?.premiseId)
    }
  })

  const { formState, handleSubmit } = form

  useFormDirty(onFormDirty, formState)

  const handleFormSubmit = async (data: CourierPassFormData) => {
    await onSubmit(data)
  }

  return (
    <DrawerFormLayout
      onSubmit={handleSubmit(handleFormSubmit)}
      isPending={isPending}
      header={
        <PassFormHeader text="Разовый пропуск для пеших курьеров, доставляющих еду и другие некрупные посылки" />
      }
    >
      <div className="form-block-cover grid grid-cols-2 gap-24 p-20 xs:grid-cols-1 xs:gap-16 xs:p-16">
        <FormProvider {...form}>
          <RequestDatePickerFormBlock passError={passError} />
        </FormProvider>
        <FormProvider {...form}>
          <RequestRoomPickerFormBlock />
        </FormProvider>
      </div>
    </DrawerFormLayout>
  )
}

export { CourierPassForm }
